/*
 *  Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 *  All information herein, source code below as well as the Morpheus system itself and all related
 *  software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 *  Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 *  is prohibited.
 */

import Vue from 'vue'
import Vuex from 'vuex'
import { authModule } from '@morpheus/admin/admin-vue/store/modules/auth'
import { globalModule } from '@morpheus/utils/admin-vue/store/modules/global'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    global: globalModule,
    auth: authModule
  }
})
